import React from 'react';

class ColorItem extends React.Component {
  onItemClick = () => void this.props.makeActive(this.props.info);

  render() {
    return (
      <span
        className={this.props.isSelected ? 'active' : ''}
        onClick={this.onItemClick}
        style={{ background: this.props.info.hex }}
        role="button"
        tabIndex="0"
      />
    );
  }
}

export default ColorItem;
